import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const cardShell =
  "isic-discount-card aspect-square w-full flex flex-col overflow-hidden rounded-2xl bg-white ring-1 ring-slate-100 shadow-[0_12px_34px_-18px_rgba(20,60,120,0.35)]";

export const DiscountCarousel = ({ items, gap = 24, testId }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 1,
    containScroll: false,
  });
  const [canScroll, setCanScroll] = useState(false);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  useEffect(() => {
    if (emblaApi) setCanScroll(emblaApi.scrollSnapList().length > 1);
  }, [emblaApi]);

  return (
    <div className="relative mx-auto max-w-[1220px] px-4 md:px-14" data-testid={testId}>
      <div className="overflow-hidden py-6" ref={emblaRef}>
        <div className="flex items-start" style={{ marginLeft: `-${gap}px` }}>
          {items.map((item, i) => {
            const card = item.logo ? (
              <div className={`${cardShell} items-center p-4`}>
                <div className="flex w-full flex-1 items-center justify-center">
                  <img
                    src={item.logo}
                    alt={item.alt || ""}
                    className="max-h-32 w-auto max-w-[92%] object-contain md:max-h-36"
                    style={item.logoScale ? { transform: `scale(${item.logoScale})` } : undefined}
                    loading="lazy"
                  />
                </div>
                <p className="isic-clamp-3 mt-3 text-center text-sm font-semibold leading-5 text-slate-700">
                  {item.label}
                </p>
              </div>
            ) : (
              <div className={cardShell}>
                <img
                  src={item.img}
                  alt={item.alt || ""}
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
            );
            return (
              <div
                key={item.alt || item.label || i}
                className="isic-carousel-slide min-w-0 shrink-0 grow-0"
                style={{ paddingLeft: `${gap}px` }}
              >
                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                    data-testid={`${testId}-item-${i}`}
                  >
                    {card}
                  </a>
                ) : (
                  <div data-testid={`${testId}-item-${i}`}>{card}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {canScroll && (
        <>
          <button
            onClick={scrollPrev}
            aria-label="Anterior"
            className="isic-nav-btn absolute left-0 top-1/2 hidden -translate-y-1/2 md:flex"
            data-testid={`${testId}-prev`}
          >
            <ChevronLeft size={26} strokeWidth={2.4} />
          </button>
          <button
            onClick={scrollNext}
            aria-label="Următor"
            className="isic-nav-btn absolute right-0 top-1/2 hidden -translate-y-1/2 md:flex"
            data-testid={`${testId}-next`}
          >
            <ChevronRight size={26} strokeWidth={2.4} />
          </button>
        </>
      )}
    </div>
  );
};
